import { gql } from '@apollo/client';

// Lightweight query to get just counts for the dashboard
export const GET_ACTIVITY_COUNTS = gql`
  query GetActivityCounts($teamId: ID!) {
    getActivityCounts(teamId: $teamId) {
      pendingApprovalsCount
      dealInvitationsCount
      documentsInReviewCount
      documentsInSigningPrepCount
      documentsOutForSigningCount
    }
  }
`;

// Server-side filtered activity data query
export const GET_ACTIVITY_DATA = gql`
  query GetActivityData($teamId: ID!) {
    getActivityData(teamId: $teamId) {
      pendingApprovals {
        id
        title
        status
        dealId
        dealTitle
      }
      dealInvitations {
        id
        title
        status
        invitationSentByName
      }
      documentsInReview {
        id
        title
        status
        dealId
        dealTitle
      }
      documentsInSigningPrep {
        id
        title
        status
        dealId
        dealTitle
        signerEmails
      }
      documentsOutForSigning {
        id
        title
        status
        dealId
        dealTitle
        signerEmails
      }
    }
  }
`;
